export default {
    userData: {},
    userCookieInfo: {
        permissions: []
    },
    notificationsSettings: {},
    userProfileDDLs: {
        LANG: [],
        POSITION: []
    },
    myRoles: [],
    delegationId: "",
    userListDelegation: [],
    userProfileImage: "/identity/tenants/users/avatars/s",
    userEmail: "",
    userName: "",
    userId: "",
    needsTaskRedirect: true,
    userIsManager: false,
    timestampCookie: null
};
